var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$fetchState.pending)?_c('GridSkeletonLoader',{attrs:{"render-banner":false}}):(_vm.feed && _vm.feed.length > 0)?_c('FeedParser',{attrs:{"feed":_vm.feed,"type":_vm.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }